import { useStaticQuery, graphql } from "gatsby"

const MainVisuals = () => {
  const { allFile: mainvisual } = useStaticQuery(graphql`
    query {
      allFile(
        filter: { relativeDirectory: { eq: "mainvisual" } }
        sort: { fields: [relativePath], order: ASC }
      ) {
        nodes {
          childImageSharp {
            fluid(maxWidth: 800) {
              originalName
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `) //(quality: 90)

  return mainvisual.nodes
}

export default MainVisuals
